import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import _ from 'lodash'

import AutoFocus from '../AutoFocus'

import iconStyle from 'Styles/icon.css'
import style from './style.css'

import xIcon from 'Assets/x-icon-red.svg'
import checkIcon from 'Assets/check-green.svg'

import replaceUnderscores from '../../../client/lib/replaceUnderscores'

function AnswerChoice (props) {
  let correctnessClass
  let radioButton
  let inputDisabled = false

  function onKeyDown (event) {
    if (event.keyCode === 13) {
      event.target.click()
    }
  }

  if (props.isAnswered && props.isCorrect) {
    correctnessClass = style.correct
    radioButton = (
      <img
        data-test-id="correctCyuAnswer"
        className={classnames(iconStyle.small, style.answerButtonCorrect)}
        src={checkIcon}
        alt={'Correct: ' + props.label}
      />
    )
    inputDisabled = true
  } else if (props.isAnswered && !props.isCorrect) {
    correctnessClass = style.incorrect
    radioButton = (
      <img
        className={classnames(iconStyle.small, style.answerButtonIncorrect)}
        src={xIcon}
        alt={'Incorrect: ' + props.label}
      />
    )
    inputDisabled = true
  } else if (props.isRemoved) {
    correctnessClass = style.removed
    radioButton = (
      <span
        className={classnames(style.answerButtonBase, style.answerButtonRemoved)}
        onKeyDown={(event) => onKeyDown(event)}
        tabIndex="-1"
      />
    )
  } else if (props.isComplete) {
    correctnessClass = style.completedQuestion
    radioButton = (
      <span
        className={classnames(style.answerButtonBase, style.answerButtonRemoved)}
        onKeyDown={(event) => onKeyDown(event)}
        tabIndex="-1"
      />
    )
  } else {
    correctnessClass = ''
    radioButton = (
      <span
        className={classnames(style.answerButtonBase, style.answerButtonOpen,
          { [style.completedRadio]: props.isComplete })}
        onKeyDown={(event) => onKeyDown(event)}
        tabIndex="-1"
      />
    )
  }

  const isDisabled = props.isComplete || props.isRemoved || inputDisabled

  return (
    <label
      className={classnames(style.answerChoice, correctnessClass, { [style.completedQuestion]: props.isComplete })}
    >
      {
        !isDisabled
          ? (
            <input
              name="multipleChoice"
              type="radio"
              value={props.value}
              tabIndex="0"
              onClick={(event) => props.onClick(event)}
              id={`multipleChoice${props.idx}`}
            />
            )
          : null
      }
      {radioButton}
      <div
        data-test-id="cyuAnswerChoice"
        aria-hidden="true"
        className={classnames(style.answerText, { [style.answerTextUnselected]: props.isComplete && !props.isCorrect })}
        dangerouslySetInnerHTML={{ __html: props.label }}
        htmlFor={`multipleChoice${props.idx}`}
      />
    </label>
  )
}
AnswerChoice.propTypes = {
  value: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  isCorrect: PropTypes.bool.isRequired,
  isAnswered: PropTypes.bool.isRequired,
  isRemoved: PropTypes.bool.isRequired,
  isComplete: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  idx: PropTypes.number
}

export default class MultipleChoice extends Component {
  constructor (props) {
    super(props)

    this.state = {
      currentlySelectedInput: null
    }
  }

  onKeyDown (event) {
    if (event.keyCode === 13) {
      event.target.click()
    }
  }

  onAnswer (event) {
    if (this.state.currentlySelectedInput === event.target) {
      event.target.checked = false
      this.setState({
        currentlySelectedInput: null
      })
      this.props.onAnswer(null)
    } else {
      this.setState({
        currentlySelectedInput: event.target
      })

      this.props.onAnswer(event.target.value)
    }
  }

  render () {
    const question = this.props.question
    if (_.isEmpty(question)) {
      return null
    }

    const isComplete = question.isComplete || _.some(question.choices, ({ isAnswered }) => isAnswered)

    return (
      <div data-test-id="MultipleChoice">
        <AutoFocus>
          <span className={classnames('sr-only', style.selectPrompt)}>
            Please choose the correct answer from the following choices, and then
            select the submit answer button.
          </span>
        </AutoFocus>
        <form className={style.answerContainer}>
          <fieldset>
            <legend>
              <h2
                className={style.prompt}
                dangerouslySetInnerHTML={{ __html: replaceUnderscores(question.prompt) }}
              />
            </legend>
            {
              _.map(question.choices, (choice, idx) => {
                return (
                  <AnswerChoice
                    key={choice.value}
                    value={choice.value}
                    label={choice.label}
                    isCorrect={choice.isCorrect}
                    isAnswered={choice.isAnswered}
                    isRemoved={choice.isRemoved}
                    isComplete={isComplete}
                    onClick={this.onAnswer.bind(this)}
                    idx={idx}
                  />
                )
              })
            }
          </fieldset>
        </form>
      </div>
    )
  }
}

MultipleChoice.propTypes = {
  /**
   * @param {Number}
   */
  onAnswer: PropTypes.func.isRequired,
  question: PropTypes.shape({
    prompt: PropTypes.string.isRequired,
    isComplete: PropTypes.bool.isRequired,
    choices: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.number.isRequired, // value passed to onAnswer
        label: PropTypes.string.isRequired,
        isAnswered: PropTypes.bool.isRequired,
        isCorrect: PropTypes.bool.isRequired,
        isRemoved: PropTypes.bool.isRequired
      })
    ).isRequired
  }).isRequired
}
